import React, { useState } from 'react';
import { NonAuthRoutes } from '../url';
import { Icon } from '@iconify/react';
import { AiOutlineClose, AiOutlineMenu } from 'react-icons/ai';
import logo from '../assets/images/logos/logo.png';
import { useNavigate } from 'react-router-dom';

const Navbar = ({ activePage }) => {
  const [nav, setNav] = useState(false);
  const [dropdown, setDropdown] = useState(false);

  const handleNav = () => {
    setNav(!nav);
  };

  const navigate = useNavigate();

  const handleDropdown = () => {
    setDropdown(!dropdown);
  };

  return (
    <div className="fixed w-full  bg-white bg-opacity-50 top-0 z-50">
      <div className="container mx-auto h-24 flex justify-between items-center text-black">
        <img src={logo} className="w-24" alt="diakrino_logo" />

        <div className="md:hidden">
          <button onClick={handleNav}>
            {nav ? <AiOutlineClose size={20} /> : <AiOutlineMenu size={20} />}
          </button>
        </div>

        <ul className={`hidden md:flex space-x-6 items-center ${nav ? 'hidden' : 'flex'}`}>
          <li className={activePage === 'Home' ? 'text-gray-700' : 'text-black hover:text-diakrino-orange'}>
            <button onClick={() => navigate(NonAuthRoutes.Home)}>Home</button>
          </li>
          <li className={activePage === 'Company' ? 'text-gray-700' : 'text-black hover:text-diakrino-orange'}>
            <button onClick={() => navigate(NonAuthRoutes.About)}>About Us</button>
          </li>
          <li className={`relative ${activePage === 'Resources' ? 'text-gray-700' : 'text-black hover:text-diakrino-orange'}`}>
            <div className="flex items-center" onClick={handleDropdown}>
              <span className="mr-2">Services</span>
              <Icon icon="gridicons:dropdown" color="#ED7458" width="20" height="20" className="inline-block align-middle" />
            </div>
            {dropdown && (
              <div className="absolute left-0 z-10 mt-2 p-2 w-48 bg-white rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                <div className="py-1">
                  <button
                    onClick={() => navigate(NonAuthRoutes.CyberSecurity)}
                    className="text-gray-700 block px-4 py-2 text-sm hover:text-white hover:bg-diakrino-orange"
                  >
                    CyberSecurity
                  </button>
                  <button
                    onClick={() => navigate(NonAuthRoutes.GreenEnergy)}
                    className="text-gray-700 block px-4 py-2 text-sm hover:text-white hover:bg-diakrino-orange"
                  >
                    Oil and Gas
                  </button>
                  <button
                    onClick={() => navigate(NonAuthRoutes.GreenEnergy)}
                    className="text-gray-700 block px-4 py-2 text-sm hover:text-white hover:bg-diakrino-orange"
                  >
                    Renewable Energy
                  </button>
                  <button
                    onClick={() => navigate(NonAuthRoutes.Contact)}
                    className="text-gray-700 block px-4 py-2 text-sm hover:text-white  hover:bg-diakrino-orange"
                  >
                    Consultancy
                  </button>
                </div>
              </div>
            )}
          </li>
          <li className={activePage === 'Brochures' ? 'text-gray-700' : 'text-black hover:text-diakrino-orange'}>
            <button onClick={() => navigate(NonAuthRoutes.Brochure)}>Brochures</button>
          </li>
          <li className={activePage === 'Contact' ? 'text-gray-700' : 'text-black hover:text-diakrino-orange'}>
            <button onClick={() => navigate(NonAuthRoutes.Contact)}>Contact</button>
          </li>
        </ul>
      </div>

      {nav && (
        <ul className="md:hidden bg-white text-black px-4 py-2">
          <li className={activePage === 'Home' ? 'text-gray-700' : 'text-black hover:text-diakrino-orange'}>
            <button onClick={() => navigate(NonAuthRoutes.Home)}>Home</button>
          </li>
          <li className={activePage === 'Company' ? 'text-gray-700' : 'text-black hover:text-diakrino-orange'}>
            <button onClick={() => navigate(NonAuthRoutes.About)}>About Us</button>
          </li>
          <li className={`relative ${activePage === 'Resources' ? 'text-gray-700' : 'text-black hover:text-diakrino-orange'}`}>
            <div className="flex items-center" onClick={handleDropdown}>
              <span className="mr-2">Services</span>
              <Icon icon="gridicons:dropdown" color="#ED7458" width="20" height="20" className="inline-block align-middle" />
            </div>
            {dropdown && (
              <div className="pl-4 mt-2">
                <button
                  onClick={() => navigate(NonAuthRoutes.CyberSecurity)}
                  className="text-gray-700 block py-2 text-sm hover:text-white hover:bg-diakrino-orange"
                >
                  CyberSecurity
                </button>
                <button
                  onClick={() => navigate(NonAuthRoutes.OilAndGas)}
                  className="text-gray-700 block py-2 text-sm hover:text-white hover:bg-diakrino-orange"
                >
                  Oil and Gas
                </button>
                <button
                  onClick={() => navigate(NonAuthRoutes.GreenEnergy)}
                  className="text-gray-700 block py-2 text-sm hover:text-white hover:bg-diakrino-orange"
                >
                  Renewable Energy
                </button>
                <button
                  onClick={() => navigate(NonAuthRoutes.Consultancy)}
                  className="text-gray-700 block py-2 text-sm hover:text-white hover:bg-diakrino-orange"
                >
                  Consultancy
                </button>
              </div>
            )}
          </li>
          <li className={activePage === 'Brochures' ? 'text-gray-700' : 'text-black hover:text-diakrino-orange'}>
            <button onClick={() => navigate(NonAuthRoutes.Brochures)}>Brochures</button>
          </li>
          <li className={activePage === 'Contact' ? 'text-gray-700' : 'text-black hover:text-diakrino-orange'}>
            <button onClick={() => navigate(NonAuthRoutes.Contact)}>Contact</button>
          </li>
        </ul>
      )}
    </div>
  );
};

export default Navbar;
